import {ListModel} from '../../shared/models/list.model';
import {Utilities} from '../../shared/utilities/utilities.model';
import {ThreadItemList} from './thread-item-list.model';

export class ThreadsList extends ListModel<ThreadItemList> {
	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach(thread => this.items.push(new ThreadItemList(thread)));
		}
	}
}
